import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "education-form" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["disabled", "required", "required-mark", "max", "value"]
const _hoisted_5 = ["checked"]
const _hoisted_6 = ["placeholder", "minlengthLabel", "value", "minlength", "maxlength"]
const _hoisted_7 = { class: "education-form__actions" }
const _hoisted_8 = ["disabled"]

import {useTranslation} from '@malt/vue3-use';
    import {EducationResource} from '@/common/api/api-raw-types';
    import {ref, toRef, watch, computed} from 'vue';
    import {useStore} from 'vuex';
    import getters from '@/profile-creation-wizard/store/completion/getters';

    type EducationFormEvents = {
        (e: 'education-form:cancel'): void;
        (e: 'education-form:edit', education: EducationResource): void;
        (e: 'education-form:add', education: EducationResource): void;
    };
    const minYear = 1900;

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EducationForm',
  props: {
    educationToEdit: {}
  },
  emits: ["education-form:cancel", "education-form:edit", "education-form:add"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const {msg} = useTranslation();
    const store = useStore();

    const emits = __emit;
    const textAreaLengthConfig = toRef(store.getters[getters.educationDescriptionRule]);
    const descriptionMinLength = computed(() => (education.value.content.length > 0 ? textAreaLengthConfig.value.min : 0));

    const educationForm = ref(null);
    const isSaveDisabled = ref(!props.educationToEdit);

    const education = ref<EducationResource>(props.educationToEdit ? {...props.educationToEdit} : {content: ''});
    const graduationYearInput = ref(null);
    const isInProgress = ref(false);
    isInProgress.value = education.value.graduationYear === null;
    const currentYear = new Date().getFullYear();
    function handleSchoolChanged(event: CustomEvent) {
        education.value.title = event.detail.value;
    }

    function handleDegreeChanged(event: CustomEvent) {
        education.value.description = event.detail.value;
    }

    function handleGraduationYearChanged(event: CustomEvent) {
        education.value.graduationYear = event.detail.value;
    }

    function handleStillProgressChanged(event: CustomEvent) {
        isInProgress.value = event.detail;

        if (event.detail === true) {
            education.value.graduationYear = null;
            graduationYearInput.value.invalid = false;
            graduationYearInput.value.required = false;
        } else {
            education.value.graduationYear = graduationYearInput.value.value;
        }
    }

    function handleDescriptionChanged(event: CustomEvent) {
        education.value.content = event.detail.value;
    }

    function handleFormSubmit() {
        if (props.educationToEdit) {
            emits('education-form:edit', education.value);
        } else {
            emits('education-form:add', education.value);
        }
    }

    function handleCancel() {
        emits('education-form:cancel');
        if (props.educationToEdit) {
            education.value = {...props.educationToEdit};
        }
    }

    function checkValidty() {
        return (
            education.value.title &&
            education.value.description &&
            (isInProgress.value ? true : education.value.graduationYear >= minYear && education.value.graduationYear <= currentYear) &&
            contentIsValid()
        );
    }

    function contentIsValid(): boolean {
        return (
            education.value.content.length === 0 ||
            (education.value.content.length >= textAreaLengthConfig.value.min && education.value.content.length <= textAreaLengthConfig.value.max)
        );
    }

    watch(
        () => [education.value, isInProgress.value],
        () => {
            isSaveDisabled.value = !checkValidty();
        },
        {deep: true},
    );

return (_ctx: any,_cache: any) => {
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      ref_key: "educationForm",
      ref: educationForm,
      "data-testid": "singup-education-form",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleFormSubmit()), ["prevent"]))
    }, [
      _createElementVNode("joy-input", {
        "data-testid": "singup-education-form-description",
        required: "",
        "required-mark": "",
        value: education.value.description,
        onJoyInputChange: handleDegreeChanged
      }, _toDisplayString(_unref(msg)('profile.new.education.description')), 41, _hoisted_2),
      _createElementVNode("joy-input", {
        "data-testid": "singup-education-form-title",
        required: "",
        "required-mark": "",
        value: education.value.title,
        onJoyInputChange: handleSchoolChanged
      }, _toDisplayString(_unref(msg)('profile.new.education.title')), 41, _hoisted_3),
      _createVNode(_component_VJoyWrapper, { align: "flex-end" }, {
        default: _withCtx(() => [
          _createElementVNode("joy-input", {
            ref_key: "graduationYearInput",
            ref: graduationYearInput,
            "data-testid": "singup-education-form-graduation-year",
            type: "number",
            disabled: isInProgress.value,
            required: !isInProgress.value,
            "required-mark": !isInProgress.value,
            min: minYear,
            max: _unref(currentYear),
            value: education.value.graduationYear,
            onJoyInputChange: handleGraduationYearChanged
          }, _toDisplayString(_unref(msg)('profile.new.education.graduation.year')), 41, _hoisted_4),
          _createElementVNode("joy-checkbox", {
            "data-testid": "singup-education-form-in-progress",
            checked: isInProgress.value,
            onJoyCheckboxChange: handleStillProgressChanged
          }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.education.inprogress')), 41, _hoisted_5)
        ]),
        _: 1
      }),
      (textAreaLengthConfig.value)
        ? (_openBlock(), _createElementBlock("joy-textarea", {
            key: 0,
            "data-testid": "singup-education-form-content",
            placeholder: _unref(msg)('profile.creation.completion.wizard.v2.education.description.placeholder'),
            minlengthLabel: 
                    _unref(msg)(
                        'profile.creation.completion.wizard.v2.education.description.maxlengthlabel',
                        textAreaLengthConfig.value.min,
                        textAreaLengthConfig.value.max,
                    )
                ,
            value: education.value.content,
            invalid: false,
            autogrow: "",
            minlength: descriptionMinLength.value,
            maxlength: textAreaLengthConfig.value.max,
            onJoyTextareaChange: handleDescriptionChanged
          }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.education.description.label')), 41, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("joy-button", {
          "data-testid": "singup-education-form-submit",
          type: "reset",
          size: "small",
          variant: "secondary",
          onClick: handleCancel
        }, _toDisplayString(_unref(msg)('general.cancel')), 1),
        _createElementVNode("joy-button", {
          "data-testid": "singup-education-form-cancel",
          size: "small",
          variant: "primary",
          type: "submit",
          disabled: isSaveDisabled.value
        }, _toDisplayString(_ctx.educationToEdit ? _unref(msg)('general.save') : _unref(msg)('general.add')), 9, _hoisted_8)
      ])
    ], 544)
  ]))
}
}

})